import { useSyncExternalStore } from 'react'

const INPUT_SELECTOR = 'input, textarea, [contenteditable="true"]'

let keyboardVisible = false
const listeners = new Set<() => void>()

function notify() {
  listeners.forEach((l) => l())
}

function setVisible(value: boolean) {
  if (keyboardVisible === value) return
  keyboardVisible = value
  notify()
}

function isInputElement(el: EventTarget | null): boolean {
  return el instanceof HTMLElement && el.matches(INPUT_SELECTOR)
}

// Единый глобальный слушатель — инициализируется один раз
let initialized = false
function init() {
  if (initialized) return
  initialized = true

  // focusin/focusout всплывают, в отличие от focus/blur
  document.addEventListener('focusin', (e) => {
    if (isInputElement(e.target)) setVisible(true)
  })

  document.addEventListener('focusout', (e) => {
    if (isInputElement(e.target)) {
      // Небольшая задержка: если фокус переходит на другой input,
      // focusin нового сработает раньше чем таймаут
      setTimeout(() => {
        const active = document.activeElement
        if (!active || !active.matches(INPUT_SELECTOR)) {
          setVisible(false)
        }
      }, 80)
    }
  })
}

function subscribe(callback: () => void) {
  init()
  listeners.add(callback)
  return () => listeners.delete(callback)
}

function getSnapshot() {
  return keyboardVisible
}

/**
 * Определяет, открыта ли виртуальная клавиатура,
 * отслеживая focusin/focusout на input/textarea элементах.
 *
 * Работает надёжно в Telegram WebView где visualViewport API
 * не реагирует на клавиатуру.
 */
export function useKeyboardVisible(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot)
}
